const loadDropdown = () => {
  document.addEventListener('click', event => {
    const dropdowns = document.querySelectorAll('.dropdown');
    dropdowns.forEach(dropdown => {
      if (!dropdown.contains(event.target)) {
        const menu = dropdown.querySelector('.dropdown-menu');
        const toggle = dropdown.querySelector('.dropdown-toggle');
        if (menu) menu.classList.remove('block');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.addEventListener('click', event => {
    const toggle = event.target.closest('.dropdown-toggle');
    if (!toggle) return;

    const dropdown = toggle.closest('.dropdown');
    if (!dropdown) return;

    event.preventDefault();
    event.stopPropagation();

    const menu = dropdown.querySelector('.dropdown-menu');
    if (!menu) return;

    const allDropdowns = document.querySelectorAll('.dropdown');
    allDropdowns.forEach(otherDropdown => {
      if (otherDropdown !== dropdown) {
        const otherMenu = otherDropdown.querySelector('.dropdown-menu');
        const otherToggle = otherDropdown.querySelector('.dropdown-toggle');
        if (otherMenu) otherMenu.classList.remove('block');
        if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
      }
    });

    const isOpen = menu.classList.contains('block');
    menu.classList.toggle('block');
    toggle.setAttribute('aria-expanded', !isOpen);
  });
};

export default loadDropdown;
